import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { Box, Text } from '@chatterbug/aaron'

const VocabularyWord = ({ word, linkToItem, studyCard }) => {
  const tooltip = studyCard?.tooltip
  const progress = studyCard?.progress
  // from the backend
  // INTERVAL_TAGS = {
  //   100 => 'mastered',
  //   50  => 'well_known',
  //   25  => 'known',
  //   6.1 => 'improving', # need to be over 6.0
  //   1   => 'learning',
  //   0   => 'new'
  // }
  const getProgressInfo = () => {
    if (progress === 'mastered') {
      return {
        // purple = mastered
        style: {
          backgroundColor: 'octopus1',
          borderColor: 'octopus4',
        },
      }
    }
    if (progress?.endsWith('known')) {
      // blue = known and well-known
      return {
        style: {
          backgroundColor: progress === 'known' ? 'dolphin1' : 'dolphin2',
          borderColor: 'dolphin4',
        },
      }
    }
    if (progress === 'improving') {
      // dark yellow = improving
      return {
        style: {
          // these colors are not in the specs so I took them from the current page
          backgroundColor: '#fceea9',
          borderColor: '#f9d958',
        },
      }
    }
    if (progress === 'learning') {
      // yellow = learning
      return {
        style: {
          backgroundColor: '#fef6d7',
          borderColor: '#f9d958',
        },
      }
    }
    // unseen
    return {
      style: {
        backgroundColor: 'gray99',
        borderColor: 'gray60',
      },
    }
  }

  const wordInfo = getProgressInfo()
  const wordStyle = wordInfo?.style
  const name = word

  return (
    <Box
      as={linkToItem ? 'a' : 'span'}
      href={linkToItem || null}
      display="inline-flex"
      borderRadius="1,5x"
      color="black"
      justifyContent="center"
      alignItems="center"
      px="3x"
      minHeight={36}
      sx={{
        position: 'relative',
        borderStyle: 'solid',
        borderWidth: '2px',
        textDecoration: 'none',
        cursor: linkToItem ? 'pointer' : null,
        ...wordStyle,
      }}
      data-tip={tooltip}
      data-for={`tooltip-${name}`}
      translate="no"
    >
      <Text>{word}</Text>
      {tooltip && (
        <ReactTooltip
          id={`tooltip-${name}`}
          place="bottom"
          className="react-tooltip-small"
        />
      )}
    </Box>
  )
}

VocabularyWord.propTypes = {
  word: PropTypes.string.isRequired,
  linkToItem: PropTypes.string,
  studyCard: PropTypes.shape({
    tooltip: PropTypes.string,
    progress: PropTypes.string,
  }),
}

export default VocabularyWord
